import Head from 'next/head';
import { NextPage } from 'next';

import {
  SignupDetails,
} from '@/core/interfaces/common';
import { wrapper } from '@/core/store/store';

import { SignupFormWidget } from '@/features/SignupFormWidget';

import { fetchSingupData } from '@/utils/requestHelpers';

import ErrorPage from '../404';

interface SignupWidgetProps {
  signupDetails?: SignupDetails;
}

const SignupWidget: NextPage<SignupWidgetProps> = (initialProps: SignupWidgetProps) => {
  const {
    signupDetails,
  } = initialProps;

  if (!signupDetails) {
    return (
      <>
        <Head>
          <meta
            name="robots"
            content="noindex"
          />
        </Head>
        <ErrorPage />
      </>
    );
  }

  const title = `${signupDetails.headlineConfig.headlineText || 'Sign up'} | ${signupDetails.organization.name}`;

  return (
    <>
      <Head>
        <title key="title">{title}</title>
        <meta
          property="og:title"
          content={title}
        />
        <meta
          property="og:image"
          content={signupDetails.signupPageImage}
        />
      </Head>
      <SignupFormWidget signupDetails={signupDetails} />
    </>
  );
};

SignupWidget.getInitialProps = wrapper.getInitialPageProps(() => async ({
  query,
  res,
}) => {
  const signupDetails = await fetchSingupData(query.uuid);

  if (res && !signupDetails) {
    res.statusCode = 404;
  }

  return {
    signupDetails,
  };
});

export default SignupWidget;
